import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import logger from "redux-logger";
import rootReducer from "./reducers";

export let store;
export default function configureStore() {
  var initialState = {
    atlete: {
      activitiesGarminLoading: false,
      userID: undefined,
    },
    teamgames: {
      gameEvents: [],
      gameData: {
        "teamAInfo": {
          "name": "Equipo A",
          "coach": "Vacio",
          "players": []
        },
        "teamBInfo": {
          "name": "Equipo B",
          "coach": "Vacio",
          "players": []
        }
      }
    },
    organizer: {
      snackbar: { show: false, text: "", duration: 0 },
    },
  };

  store = createStore(
    rootReducer,
    initialState,
    applyMiddleware(thunk, logger)
  );

  return store;
}
